import { api } from "@";
import { success, swal } from "@";
import { parseBoolean } from "@";
import { datesToISO } from "@";
import { deleteProject } from "@/services/api.js";

// Function to delete an item from the database based on type
export const deleteFromDB = async (id, type) => {
  const res = await swal();
  if (res.isConfirmed) {
    try {
      switch (type) {
        case "projects":
          await deleteProject(id);
          break;
        case "affiliateUsers":
          await api.delete(`/api/AdminAffiliate/${id}`);
          break;
        case "giftProjects":
          await api.delete(`/api/AdminGiftProject/gift-projects/${id}`);
          break;
        case "affiliateLink":
          await api.delete(`/api/AdminAffiliateLink/${id}`);
          break;
        case "messages":
          await api.delete(`/api/AdminSms/delete-sms-message/${id}`);
          break;
        case "automatedMessages":
          await api.delete(`/api/AdminScheduledMessages/${id}`);
          break;
        case "smsCampaignsLinks":
          await api.patch(`/api/AdminCampaign/${id}/archive?isArchived=true`);
          break;
        case "sliders":
          await api.delete(`/api/AdminHomeSlider/${id}`);
          break;
        case "pages":
          await api.delete(`/api/AdminWebsitePages/${id}`);
          break;
        case "MainStatistics":
          await api.delete(`/api/AdminMainStatistics/${id}`);
          break;

        case "partners":
          await api.delete(`/api/AdminPartners/${id}`);
          break;
        case "PopupScreen":
          await api.delete(`/api/AdminPopupScreen/${id}`);
          break;
        case "users":
          await api.delete(`/api/AdminUser/${id}/delete`);
          break;
        case "classifications":
          await api.delete(`/api/AdminClassifications/${id}`);
          break;
        case "accounts":
          await api.delete(`/api/AdminBank/bank-account/${id}`);
          break;
        case "licenses":
          await api.delete(`/api/AdminCharity/licences/${id}`);
          break;
        case "drivers":
          await api.put(
            `/api/Driver/admin/change-status/${id}?isActive=${false}`,
          );
          break;
        case "fastDonations":
          await api.delete(`/api/AdminFastDonation/${id}`);
          break;
        case "themes":
          await api.delete(`/api/AdminTheme/themes/${id}`);
          break;
        case "landing-pages":
          await api.delete(`/api/AdminLandingPage/landing-pages/${id}`);
          break;
      }
      await success("تم الحذف بنجاح");
      return 200;
    } catch (error) {}
  }
};

// search values payload for projects
export const projectSearchValuesPayload = (page, perSize, search) => ({
  page: page,
  pageSize: perSize,
  title: search?.title,
  toAmount: parseInt(search?.toAmount),
  fromAmount: parseInt(search?.fromAmount),
  isActive: parseBoolean(search?.isActive),
  toDate: datesToISO(search?.toDate) || null,
  isArchived: parseBoolean(search?.isArchived),
  fromDate: datesToISO(search?.fromDate) || null,
  isCompleted: parseBoolean(search?.isCompleted),
  showInHomePage: parseBoolean(search?.showInHomePage),
  classificationIds: search?.classificationIds
    ? [parseInt(search.classificationIds)]
    : [],
});
